import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['map', 'delivery', 'center'];

  connect() {
    if (window.ymaps) {
      this.initMap();
    } else {
      this.loadScript();
    }
  }

  loadScript() {
    let script = document.createElement('script');
    const prior = document.getElementsByTagName('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = (_, isAbort) => {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = script.onreadystatechange = null;
        script = undefined;

        if (!isAbort) {
          this.initMap();
        }
      }
    };

    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&csp=true';
    prior.parentNode.insertBefore(script, prior);
  }

  initMap() {
    let controller = this;

    // debugger;
    ymaps.ready(() => {
      const map = new ymaps.Map(this.mapTarget.id, {
        center: [this.centerTarget.dataset.latitude, this.centerTarget.dataset.longitude],
        zoom: 4
      });
      map.controls.add('zoomControl', { top: 75, left: 5 });
      map.behaviors.disable('scrollZoom');
      map.controls.remove('searchControl');

      const boundsCollection = new ymaps.GeoObjectCollection();

      controller.deliveryTargets.forEach((delivery) => {
        const placemark = new ymaps.Placemark(
          [delivery.dataset.latitude, delivery.dataset.longitude],
          {
            balloonContentHeader: delivery.dataset.city,
            balloonContentBody: `${delivery.dataset.before}<br>
                                 ${delivery.dataset.departure}`,
            hintContent: delivery.dataset.city
          },
          {
            openEmptyBalloon: true,
            preset: `islands#${delivery.dataset.color}CircleIcon`
          }
        );

        boundsCollection.add(placemark);

      });

      const center = new ymaps.Placemark(
        [this.centerTarget.dataset.latitude, this.centerTarget.dataset.longitude],
        {
          hintContent: this.centerTarget.dataset.city
        },
        {
          preset: 'islands#grayDeliveryCircleIcon'
        }
      );

      boundsCollection.add(center);

      // debugger;
      map.geoObjects.add(boundsCollection);
      //map.setBounds(boundsCollection.getBounds());

      this.map = map;

    });
  }

}
